// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"InputField__ellipsis__1h8AZ","flex-child-ellipsis":"InputField__flex-child-ellipsis__sGT1G","multiplayer-cursor":"InputField__multiplayer-cursor__2kiaN"};